import useContentEditorVariantCreation from 'personalization-lib/hooks/variantCreation/useContentEditorVariantCreation';

/**
 * Hook for managing variant creation actions in content editor action bars.
 * Handles usage tracking internally.
 * @returns Function to open the variant creation panel, tooltip for
 * disabled state, loading state, visibility flags, and isUpgradeRequired for
 * showing upgrade modal.
 */
const useContentEditorCreateVariantAction = () => useContentEditorVariantCreation({
  trackingProps: {
    actionSource: 'action_bar'
  }
});
export default useContentEditorCreateVariantAction;